/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar3(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M18.92 9c-.486-3.391-3.394-6-6.92-6S5.566 5.609 5.08 9h13.84z" opacity=".3"/><path d="M17 8H7c-1.654 0-3 1.346-3 3v1h2v-1c0-.551.449-1 1-1h10c.551 0 1 .449 1 1v1h2v-1c0-1.654-1.346-3-3-3z"/><path d="M20 11.767V10c0-4.411-3.589-8-8-8s-8 3.589-8 8v1.767c-.628.562-1 1.373-1 2.233 0 1.276.823 2.397 1.992 2.816C6.396 20.028 9.043 22 12 22s5.604-1.972 7.008-5.184A3.008 3.008 0 0 0 21 14c0-.86-.372-1.671-1-2.233zm-1.863 3.214-.585.081-.211.551C16.302 18.319 14.256 20 12 20s-4.302-1.681-5.34-4.386l-.211-.551-.585-.081A.999.999 0 0 1 5 14c0-.36.186-.682.498-.861L6 12.851V10c0-3.309 2.691-6 6-6s6 2.691 6 6v2.851l.502.288A.982.982 0 0 1 19 14a.997.997 0 0 1-.863.981z"/></svg>
  );
}

export default Avatar_icn_avatar3;
